<div class="activation-wrapper" *ngIf="!loadingStatus">
  <div class="activation-card" *ngIf="activationRequired; else alreadyActivated">
    <h2 class="text-dark">Activation employe</h2>
    <p class="subtitle">Premiere connexion: confirmez votre matricule et changez le mot de passe provisoire.</p>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <label for="matriculeEmploye">Matricule employe</label>
      <input id="matriculeEmploye" type="text" formControlName="matriculeEmploye" />

      <label for="password" class="text-dark">Nouveau mot de passe</label>
      <input id="password" type="password" formControlName="password" autocomplete="new-password" />

      <label for="confirmPassword" class="text-dark">Confirmer le mot de passe</label>
      <input id="confirmPassword" type="password" formControlName="confirmPassword" autocomplete="new-password" />

      <button type="submit" [disabled]="loadingSubmit">
        {{ loadingSubmit ? 'Activation...' : 'Activer mon compte' }}
      </button>
    </form>

    <p class="ok" *ngIf="infoMessage">{{ infoMessage }}</p>
    <p class="err" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>

  <ng-template #alreadyActivated>
    <div class="activation-card">
      <h2>Compte deja active</h2>
      <p>Redirection vers votre espace partenaire...</p>
    </div>
  </ng-template>
</div>